import OurProducts from 'components/Sections/OurProducts';
import Hero from './Hero';
import Reviews from 'components/Sections/Reviews';
import Benefits from 'components/Sections/Benefits';
import FAQ from 'components/Sections/FAQ';
import GetStarted from 'components/Sections/GetStarted';
import CurrentLocationTable from './LocationTable';
import LocationInfo from './LocationInfo';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    fetchCurrentLocation,
    selectCurrentLocationIsLoading,
    selectCurrentLocations,
    selectCurrentLocationsBenefits,
    selectCurrentLocationsCTA,
    selectCurrentLocationsFAQ,
    selectCurrentLocationsProducts,
    selectCurrentLocationsReviews,
    selectCurrentLocationsSingle,
} from 'store/slices/LocationsSlice';
import { useImageLoaded } from 'hooks/useImageLoaded';
// import Preloader from "Layout/Preloader";

const CurrentProxyLocation = () => {
    const dispatch = useDispatch();
    const { countrySlug } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);

    const data = useSelector(selectCurrentLocations);
    const { title, tag, product_card } = useSelector(selectCurrentLocationsProducts);
    const singles = useSelector(selectCurrentLocationsSingle);
    const reviews = useSelector(selectCurrentLocationsReviews);
    const benefits = useSelector(selectCurrentLocationsBenefits);
    const faq = useSelector(selectCurrentLocationsFAQ);
    const cta = useSelector(selectCurrentLocationsCTA);

    const isCurrentLocationLoading = useSelector(selectCurrentLocationIsLoading);
    const isLoadedImages = useImageLoaded(countrySlug, isCurrentLocationLoading);
    useEffect(() => {
        if (countrySlug) {
            // @ts-ignore
            dispatch(fetchCurrentLocation({ countrySlug }));
        }
    }, [dispatch, countrySlug]);

    useEffect(() => {
        if (isLoadedImages && !isCurrentLocationLoading && countrySlug) {
            setIsLoading(false);
        } else setIsLoading(true);
    }, [isLoadedImages, isCurrentLocationLoading, countrySlug]);
    console.log(data);

    if (!isCurrentLocationLoading && !data) {
        navigate('*');
        return null;
    }

    return (
        !isCurrentLocationLoading && (
            <>
                <Hero />
                <OurProducts title={title} tag={tag} products={product_card} isLoading={isLoading} />
                <CurrentLocationTable isLoading={isLoading} />
                <LocationInfo data={singles} isLoading={isLoading} />
                <Reviews reviews={reviews} isLoading={isLoading} />
                <Benefits data={benefits} isLoading={isLoading} />
                <FAQ data={faq} isLoading={isLoading} />
                <GetStarted cta={cta} isLoading={isLoading} />
            </>
        )
    );
};

export default CurrentProxyLocation;
